var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewdate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_20914644721561029437",
    "data-name": 20914644721561030000,
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.312,
    height: 61.313,
    viewBox: "0 0 61.312 61.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    d: "M0,0H61.312V61.312H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    d: "M40.32,6.109H50.539a2.555,2.555,0,0,1,2.555,2.555V49.539a2.555,2.555,0,0,1-2.555,2.555H4.555A2.555,2.555,0,0,1,2,49.539V8.664A2.555,2.555,0,0,1,4.555,6.109H14.773V1h5.109V6.109H35.211V1H40.32ZM7.109,21.437V46.984H47.984V21.437Zm5.109,10.219H24.992V41.875H12.219Z",
    transform: "translate(3.109 1.555)",
    fill: "#16b1ef"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewdate);
export default __webpack_public_path__ + "static/media/reviewdate.96fbef83acbd78fb8cab57c29f93aaa4.svg";
export { ForwardRef as ReactComponent };